import popup from '../global/popup';

const zigZag = {
	zigzagVideos: document.querySelectorAll('.js-zigzag-video'),

	init: function() {
		if (!this.zigzagVideos) return;
		this.playVideos();
	},

	playVideos: function() {
		this.zigzagVideos.forEach((el) => {
			const parent = el.closest('.js-zigzag');
			const btn = parent.querySelector('.js-btn-play');
			btn.addEventListener('click', () => {
				popup.createPopup(el);
			});
		});
	}
};

export default zigZag;
